import { Injectable } from '@angular/core';
@Injectable()
export class BaseCase{
  pageTitle:string;//页面标题
  historyVisit:string;//历史拜访列表title
  arrayData: Array<any> = new Array<any>();//列表数据结构
  ListData: Array<any> = new Array<any>();//列表数据结构
  giftArrayList: Array<any> = new Array<any>();//产品退货赠品列表
  isbuttonvisble:any = true;//是否显示按钮
  boxCount:any=0;//箱规
  yearDate = new Date().getFullYear()+10; // 配置日历年份
  order: any = {
    totalCount: 0,
    totalMoney:0,
    Data:new Array<any>()
  };//已下单
  storeSearch = {
    ObjectType:1,//1 门店 ， 2 经销商
    userId:null,//人员ID
    FK_TBStoreChannel_ID:null,//渠道ID，可不传
    Code:null,//门店、经销商code（模糊查询），可不传
    Name:null,//门店、经销商名称（模糊查询），可不传
    longitude:null,//经度
    latitude:null,//纬度
    date:null,//日期
    searchType:0 //查询类型，1搜索，2筛选，3地图
  };//查询条件
  gridSearchDate:Array<any> = new Array<any>();
  ImgPreview = {
    imgUrl:[],
    index:1//初始索引
  }

  MsgList:any = [];

  FixedSubmitBtn = {
    text:"提交",
    configName:"",
    type:1,//默认1 底部通栏按钮
    isShow:false,
    isSubmitData:true, //是否可以提交
    checked :false,
    count:0
  };//是否显示及显示内容

  constructor(
      ){
  }
  /**
   * 动态加载数据方法针对列表加载数据时使用
   */
  LoadData(){

  }

}